// client/src/hooks/useIsLg.js
import { useEffect, useState } from 'react';

export const LG_MEDIA_QUERY = '(min-width: 1024px)';

const getMatches = () => {
  if (typeof window === 'undefined') return true;
  return window.matchMedia(LG_MEDIA_QUERY).matches;
};

export function useIsLg() {
  const [isLg, setIsLg] = useState(getMatches);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const media = window.matchMedia(LG_MEDIA_QUERY);
    const handler = (event) => {
      setIsLg(event.matches);
    };

    handler(media);

    if (typeof media.addEventListener === 'function') {
      media.addEventListener('change', handler);
      return () => media.removeEventListener('change', handler);
    }

    media.addListener(handler);
    return () => media.removeListener(handler);
  }, []);

  return isLg;
}

